<script lang="ts">
  import { getOperatingSystem, type OperatingSystem } from '$lib/utils/isWebAuthnSupported';
  import Button from '$components/button/Button.svelte';
  import IconShareUpRight from '$lib/icons/IconShareUpRight.svelte';
  import { onMount } from 'svelte';
  import BottomSheetBody from '$components/bottom-sheet/BottomSheetBody.svelte';
  import IconSafari from '$lib/icons/IconSafari.svelte';
  import IconChrome from '$lib/icons/IconChrome.svelte';
  import IconFidoPasskey from '$lib/icons/IconFidoPasskey.svelte';
  import IconGear2 from '$lib/icons/IconGear2.svelte';

  let os = $state<OperatingSystem | null>(null);

  onMount(() => {
    os = getOperatingSystem();
  });
</script>

<BottomSheetBody>
  <div class="grid w-full place-items-center gap-4 pt-12">
    <div class="typography-h4-semibold">Passkey creation failed</div>
    <div class="typography-body-l-regular text-foreground-default">
      Your device, browser, or password manager may not support passkeys.
    </div>
    <div class="grid w-full gap-4 pt-4 text-left">
      <div class="flex items-start gap-3">
        <div class="mt-1">
          {#if os === 'android'}
            <IconChrome class="text-foreground-burned-orange" />
          {:else}
            <IconSafari class="text-foreground-burned-orange" />
          {/if}
        </div>
        <div class="typography-body-l-regular">
          {#if os === 'ios'}
            Use Safari, Chrome or install the app
          {:else if os === 'android'}
            Use Chrome or install the app
          {:else if os === 'desktop'}
            Use Chrome or Safari
          {:else}
            Use Safari, Chrome or install the app
          {/if}
        </div>
      </div>
      <div class="flex items-start gap-3">
        <div class="mt-1">
          <IconFidoPasskey class="text-foreground-burned-orange" />
        </div>
        <div class="typography-body-l-regular">
          Use a compatible password manager like iCloud Keychain, 1Password, or LastPass.
          {#if os === 'ios'}
            Enable it under Settings → AutoFill and Passwords.
          {/if}
        </div>
      </div>
      <div class="flex items-start gap-3">
        <div class="mt-1">
          <IconGear2 class="text-foreground-burned-orange" />
        </div>
        <div class="typography-body-l-regular">
          Check your Operating System. Passkeys need:
          {#if os === 'ios'}
            iOS 16+
          {:else if os === 'android'}
            Android 9+
          {:else if os === 'desktop'}
            macOS 13+, Windows 11 (22H2+). Linux support is limited.
          {:else}
            Android 9+, iOS 16+, macOS 13+, Windows 11 (22H2+). Linux support is limited.
          {/if}
        </div>
      </div>
    </div>
    <div class="grid w-full gap-4 pt-6">
      <a
        href="https://metri.xyz/news/passkey-setup-failed-what-to-do"
        target="_blank"
        class="relative z-10 flex gap-2 text-center typography-body-l-semibold underline">
        Passkey troubleshooting guide
        <IconShareUpRight />
      </a>
      <a
        href="https://discord.com/invite/aboutcircles"
        target="_blank"
        class="relative z-10 flex gap-2 text-center text-foreground-default">
        Need more help? Join our Discord
        <IconShareUpRight />
      </a>
    </div>
    <div class="w-full pt-8">
      <Button
        ariaLabel="Passkey Troubleshooting"
        stretched
        variant="tertiary"
        onclick={() => {
          window.open('https://metri.xyz/news/passkey-setup-failed-what-to-do', '_blank');
        }}>
        Passkey Troubleshooting
      </Button>
    </div>
  </div>
</BottomSheetBody>
